// ReachOutProfileComp.jsx
import React, { useMemo } from "react";
import * as FeatherIcon from "react-feather";
import "./ReachOutProfileComp.css";

function ReachOutProfileComp({ content = {} }) {
  const { name, title, headline, email, linkedin_url, country } = content || {};

  const initials = useMemo(() => {
    if (!name) return "—";
    const parts = name.trim().split(/\s+/).slice(0, 2);
    return parts.map(p => p[0]?.toUpperCase() || "").join("") || "—";
  }, [name]);

  const safeOpen = (url) => {
    if (!url) return;
    try {
      const w = window.open(url, "_blank", "noopener,noreferrer");
      if (w) w.opener = null;
    } catch {
      // ignore
    }
  };

  return (
    <div className="ropc-card">
      {/* Top contact strip */}
      <div className="ropc-head">
        <div className="ropc-avatar" aria-hidden="true">{initials}</div>
        <div className="ropc-id">
          <h2 className="ropc-name" title={name || ""}>{name || "Unknown Contact"}</h2>
          {/* <p className="ropc-title" title={title || ""}>
            {title || "Title not available"}
          </p> */}
          {headline || title ? (
            <p className="ropc-headline" title={headline||title}>{headline||title }</p>
          ) : (
            <p className="ropc-headline ropc-muted">No headline provided</p>
          )}
        </div>

      </div>

      {/* Details list */}
      <ul className="ropc-info">
        <li>
          <span className="ropc-label">Email</span>
          {email ? (
            <a href={`mailto:${email}`} className="ropc-link" title={email}>
              {email}
            </a>
          ) : (
            <span className="ropc-muted">—</span>
          )}
        </li>
        <li>
          <span className="ropc-label">LinkedIn</span>
          {linkedin_url ? (
            <button
              type="button"
              className="ropc-link ropc-link-btn"
              onClick={() => safeOpen(linkedin_url)}
              onKeyDown={(e) => e.key === "Enter" && safeOpen(linkedin_url)}
              title="Open in new tab"
            >
              {linkedin_url}
              <FeatherIcon.ExternalLink size={14} className="ropc-link-icon" />
            </button>
          ) : (
            <span className="ropc-muted">—</span>
          )}
        </li>
        <li>
          <span className="ropc-label">Country</span>
          {country ? <span>{country}</span> : <span className="ropc-muted">—</span>}
        </li>
      </ul>
    </div>
  );
}

export default ReachOutProfileComp;
